<template>
  <slot />
</template>

<script>
import { useStore } from 'vuex'
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("collection");

export default {
  props: {
    productsPerPage: {
      type: Number,
      default: 42,
    },
    collectionId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const store = useStore()

    const parseQuery = () => {
      let filterQuery = {};
      const qs = require('query-string');
      const params = qs.parse(location.search);
      let page = parseInt(params["page"], 10);
      Object.keys(params).forEach((key) => {
        if (key.indexOf("pf_t") >= 0) {
          filterQuery[key] = Array.isArray(params[key])
            ? params[key]
            : [params[key]]
        } else if (key === 'q') {
          filterQuery[key] = params[key]
        }
      });
      return { filterQuery, page };
    }

    store.commit("collection/setCollectionId", props.collectionId)
    store.commit("collection/setProductsPerPage", props.productsPerPage)
    let query = parseQuery()
    let collectionData = document.getElementById("data-collection")
    if (
      Object.keys(query.filterQuery).length === 0 &&
      collectionData
    ) {
      collectionData = JSON.parse(collectionData.innerHTML)
      store.dispatch("collection/loadProductsFromJson", collectionData)
      store.dispatch("collection/loadFiltersFromApi")
    } else {
      store.dispatch("collection/loadFiltersAndProductsFromApi", query)
    }
  },
  data() {
    return {
      expanded: false,
      strings: window.themeVariables.i18n,
    };
  },
  methods: {
    ...mapActions([
      "selectTags",
    ]),
  },
};
</script>